import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {RouteGuard} from './helpers/route-guard';

import {HomeComponent} from './components/home/home.component';
import {HomeNabavkeComponent} from 'app/components/nabavke/home-nabavke/home-nabavke.component';
import {HomeRobnoKnjigovodstvoComponent} from 'app/components/home/home-robno-knjigovodstvo/home-robno-knjigovodstvo.component';
import {ProizvodnjaComponent} from 'app/components/proizvodnja/home-proizvodnja/proizvodnja.component';
import {HomeOsnovnaSredstvaComponent} from 'app/components/osnovnaSredstva/home-osnovna-sredstva/home-osnovna-sredstva.component';
import {LoginComponent} from './components/login/login.component';
import { ProjektiModulComponent } from './components/projekti/home-projekti/projekti.component';

const routes: Routes = [
  {path: 'ng/login', component: LoginComponent},
  {path: 'ng/home', component: HomeComponent, canActivate: [RouteGuard]},
  // { path: 'ng/error',  component: ErrorComponent },

  // RUTE ZA ROBNO KNJIGOVODSTVO - DOKUMENTA:
  {
    path: 'ng/robno-knjigovodstvo', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/document.module#DocumentModule', canActivate: [RouteGuard]
  },

  // RUTE ZA ROBNO KNJIGOVODSTVO - ŠIFARNICI:
  {
    path: 'ng/robno-knjigovodstvo-sifarnici', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/lookup.module#LookupModule', canActivate: [RouteGuard]
  },

  // RUTE ZA ROBNO KNJIGOVODSTVO - ARTIKL:
  {
    path: 'ng/robno-knjigovodstvo-artikli', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/item.module#ItemModule', canActivate: [RouteGuard]
  },

  // RUTE ZA ROBNO KNJIGOVODSTVO - MAGACIN:
  {
    path: 'ng/robno-knjigovodstvo-magacini', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/stockroom.module#StockroomModule', canActivate: [RouteGuard]
  },

  // RUTE ZA ROBNO KNJIGOVODSTVO - PARTNER:
  {
    path: 'ng/robno-knjigovodstvo-partneri', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/partner.module#PartnerModule', canActivate: [RouteGuard]
  },

  // RUTE ZA ROBNO KNJIGOVODSTVO - IYVESTAJI:
  {
    path: 'ng/robno-knjigovodstvo-izvestaji', component: HomeRobnoKnjigovodstvoComponent,
    loadChildren: 'app/modules/reports.module#ReportsModule', canActivate: [RouteGuard]
  },

  // RUTE ZA NABAVKU:
  {
    path: 'ng/nabavka', component: HomeNabavkeComponent,
    loadChildren: 'app/modules/nabavke.module#NabavkeModule', canActivate: [RouteGuard]
  },

  // RUTE ZA NOVU KOMPONENTU:
  {
    path: 'ng/proizvodnja', component: ProizvodnjaComponent,
    loadChildren: 'app/modules/proizvodnja.module#ProizvodnjaModule', canActivate: [RouteGuard]
  },

  // RUTE ZA NOVU PROJEKTE
  {
    path: 'ng/projekti', component: ProjektiModulComponent,
    loadChildren: 'app/modules/projekti.module#ProjektiModule', canActivate: [RouteGuard]
  },

  // RUTE ZA OSNOVNA SREDSTVA:
  {
    path: 'ng/osnovna-sredstva', component: HomeOsnovnaSredstvaComponent,
    loadChildren: 'app/modules/osnovnaSredstva.module#OsnovnaSredstvaModule', canActivate: [RouteGuard]
  },

  // web deo
  {path: '', redirectTo: '/ng/home', pathMatch: 'full'},
  {path: '**', redirectTo: '/ng/home'}
];

@NgModule({
  providers: [RouteGuard],
  imports: [RouterModule.forRoot(routes, {useHash: true, enableTracing: false})],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
